// src/serviceWorkerRegistration.js
let deferredPrompt;

export const register = (config = {}) => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', async () => {
      try {
        const reg = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
        console.log('[SW] Registered with scope:', reg.scope);
        reg.update();
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              nw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
        if (config.onSuccess) config.onSuccess(reg);
      } catch (err) {
        console.error('[SW] Registration failed', err);
        if (config.onError) config.onError(err);
      }
      navigator.serviceWorker.ready.then((r) => r.update());
    });
  }
};

export const captureInstallPrompt = (cb) => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    cb?.(e);
  });
  window.addEventListener('appinstalled', () => {
    console.log('SErraND app installed');
    deferredPrompt = null;
  });
};

export const triggerInstallPrompt = async () => {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  await deferredPrompt.userChoice;
  deferredPrompt = null;
};
